<!--
 * @Author: zzz
 * @Date: 2021-02-06 22:10:33
 * @LastEditTime: 2021-02-21 23:20:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \04eos-app\src\pages\testDrive\day\index.vue
-->
<template>
  <div id="Week"></div>
</template>
<script>
/* eslint-disable */
import Calendar from 'tui-calendar'
import dayjs from 'dayjs'
import { Theme, StateColors } from './config'
import 'tui-calendar/dist/tui-calendar.min.css'
export default {
  name: 'CalendarWeek',
  props: {
    schedules: {
      type: Array,
      require: true
    },
    start: {
      type: String,
      require: true
    },
    storeCode: {
      type: String
    }
  },
  watch: {
    'schedules': {
      handler () {
        this.calendarData = JSON.parse(JSON.stringify(this.schedules))
        // 增加日程
        this.schedulePush(this.calendarData)
      },
      immediately: true,
      deep: true
    },
    'start': {
      handler () {
        window.week.setDate(`${this.start} 00:00:00`)
        window.week.render()
      },
      immediately: true,
      deep: true
    }
  },
  data () {
    return {
      week: {},
      calendarData: []
    }
  },
  methods: {
    // 渲染日历
    calendarInit () {
      return new Calendar('#Week', {
        id: 'calendarWeek',
        defaultView: 'week',
        scheduleView: ['time'],
        isReadOnly: true,
        theme: Theme,
        taskView: [],
        template: {
          timegridDisplayPrimaryTime: function (time) {
            var hour = time.hour + ':00'
            return hour
          },
          time: function (schedule) {
            return `${schedule.title}`
          },
          task: function (schedule) {
            return `${schedule.title}`
          }
        },
        week: {
          showTimezoneCollapseButton: true,
          timezonesCollapsed: false,
          daynames: ['日', '一', '二', '三', '四', '五', '六'],
          timegridCurrentTime: false,
          startDayOfWeek: 0, // 一周开始的时间
          narrowWeekend: false, // 使周末栏变窄（1/2宽度）
          workweek: false, // 仅显示5天
          hourStart: 8,
          hourEnd: 21
        }
      }
      )
    },
    // 数据整理
    dataFormat (calendarData) {
      /*
        同一时段 && 同意状态的
     
      // 空数组
      let tempArr = []
      // 按开始时段过滤
      const startTime = {}
      // 过滤时段-开始时间一致
      calendarData.forEach(e => {
        // 同一日期对比
        if (!(e.start in startTime)) {
          startTime[e.start] = []
        }
        // 同一预约开始时段
        startTime[e.start].push(e)
      })
      // 判断状态
      Object.values(startTime).forEach(values => {
        // 临时存储状态
        let stateTemp = {}
        values.forEach((se, index) => {
          if (!(se.state in stateTemp)) {
            stateTemp[se.state] = 1
            // se.dateList = 1
            tempArr.push({
              ...se,
              calendarId: se['calendarId'],
              data: [se]
            })
          } else {
            stateTemp[se.state] += 1
            tempArr.forEach(e => {
              if (e.start === se.start) {
                e.data.push(se)
                // e.dateList = stateTemp[se.state]
              }
            })
          }
        })
      })
      // 设置标题
      tempArr.forEach(e => {
        e.title = e.data.length
      })
      return tempArr
       */
      /*
       同一时段 && 同意状态的
     */
      // 空数组
      let tempArr = []
      // 按开始时段过滤
      const startTime = {}
      // 过滤时段-开始时间一致
      calendarData.forEach(e => {
        // 同一日期对比
        if (!(e.date in startTime)) {
          startTime[e.date] = []
        }
        e.end = e.start
        // 同一预约开始时段
        startTime[e.date].push(e)
      })
      Object.values(startTime).forEach(values => {
        values[0].title = values.length
        values[0].category = 'time'
        tempArr.push(values[0])
      })
      return tempArr
    },
    // 添加日程
    schedulePush (calendarData) {
      const formated = this.dataFormat(calendarData)

      // 根据状态设置日历颜色
      this.calendarData.forEach(e => {
        window.week.setCalendarColor(e.calendarId, {
          color: '#FFF',
          // bgColor: StateColors[`${e.state}`],
          bgColor: '#B4B4B4',
          // borderColor: StateColors[`${e.state}`],
          dragBgColor: '#FFF'
        })
      })
      window.week.clear();
      window.week.createSchedules(formated)
      window.week.on("clickSchedule", (item) => {
        const day = dayjs(item.schedule.start).format('YYYY-MM-DD')
        this.$router.push({
          path: '/testDriveList',
          query: {
            'storeCode': this.storeCode,
            'startTime': day,
            'endTime': day
          }
        })
      });
    }
  },
  mounted () {
    window.week = this.calendarInit()
  }
}
</script>
<style lang="less">
@import "./index.less";
</style>